import { createSlice } from "@reduxjs/toolkit"

const initialStateResultadoGrillaObservaciones= {
  dataGrillaObservaciones: []
}; 

export const resultadoGrillaObservacionesSlice = createSlice({ 
  name: "resultadoGrillaObservaciones", 
  initialState: initialStateResultadoGrillaObservaciones, 
  reducers:{
    setResultadoGrilla: (state, action)=>{
      state.dataGrillaObservaciones=action.payload
    },
    resetResultadoGrilla: (state) => {
      state.dataGrillaObservaciones=initialStateResultadoGrillaObservaciones.dataGrillaObservaciones
    }
  }
});

export const {resetResultadoGrilla, setResultadoGrilla} = resultadoGrillaObservacionesSlice.actions
export default resultadoGrillaObservacionesSlice.reducer
